/**
 * useDeletePhoto Hook
 * Custom hook for deleting a profile photo
 */

import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useAuthStore } from "@/features/auth/store/authStore"
import apiClient from "@/lib/api-client"

async function deletePhoto(userId: string, photoId: string) {
  await apiClient.delete(`api/profiles/${userId}/photos/${photoId}`)
}

export function useDeletePhoto() {
  const queryClient = useQueryClient()
  const user = useAuthStore(state => state.user)
  const setUser = useAuthStore(state => state.setUser)

  return useMutation({
    mutationFn: ({ userId, photoId }: { userId: string; photoId: string }) =>
      deletePhoto(userId, photoId),
    onSuccess: async (_data, variables) => {
      // Invalidate photos query to trigger refetch with correct userId
      queryClient.invalidateQueries({ queryKey: ["photos", variables.userId] })

      // Update auth store by removing deleted photo (surgical update)
      if (user?.profile_photos) {
        setUser({
          ...user,
          profile_photos: user.profile_photos.filter(p => p.id !== variables.photoId),
        })
      }
    },
  })
}
